/**
 * Хуки-потребители контекстов действий приложения.
 *
 * Вынесены в отдельный файл чтобы Fast Refresh (HMR) работал корректно.
 * Context объекты — в ./actionsContext.ts, сам Provider — в ./ActionsProvider.tsx.
 */

import { useContext } from 'react';
import {
  AppActionsContext,
  ACTIONS_FALLBACK_VALUE,
  NoWishlistDrawerContext,
  type NoWishlistDrawerContextValue,
} from './actionsContext';
import type { AppActionsContextValue } from './model/types';

/**
 * Хук для доступа ко всем действиям приложения.
 * Возвращает noop-заглушки если контекст ещё не инициализирован (graceful degradation).
 */
export function useAppActions(): AppActionsContextValue {
  const context = useContext(AppActionsContext);
  if (!context) {
    console.warn('useAppActions: ActionsProvider not found, using fallback noop actions');
    return ACTIONS_FALLBACK_VALUE;
  }
  return context;
}

/**
 * Хук для доступа к контексту drawer'а "нет вишлиста".
 */
export function useNoWishlistDrawer(): NoWishlistDrawerContextValue {
  return useContext(NoWishlistDrawerContext);
}
